
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...urlSlug]",
      function () {
        return require("private-next-pages/[...urlSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...urlSlug]"])
      });
    }
  